<template>
  <div class="app-container">
    <div v-loading="infoLoading">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="商城状态" prop="mall_status">
          <el-switch v-model="form.mall_status" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="saveData" :loading="btnLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        infoLoading: true,
        infoQuery: {
          school_id: ""
        },
        btnLoading: false,
        form:{
          id: "",
          school_id: "",
          mall_status: 0,
        },
        rules: {
          mall_status: [{ required: true, message: "商城状态不能为空", trigger: "change" }],
        },
      };
    },
    created() {
      this.getInfo();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.infoQuery.school_id = newVal;
        this.getInfo();
      },
    },
    methods: {
      getInfo() {
        this.infoQuery.school_id = this.school_id;
        this.infoLoading = true;
        request({
          url: "/api/backend/mallConfig/info",
          method: "get",
          params: this.infoQuery
        }).then(response => {
          this.resetForm()
          if (response.data) {
            this.form = response.data;
          }
          this.infoLoading = false;

          this.$nextTick(() => {
            this.$refs["form"].clearValidate() //清除校验结果
          })
        });
      },
      resetForm() {
        this.form = {
          id: "",
          school_id: "",
          mall_status: 0,
        }
        this.btnLoading = false;
      },
      saveData() {
        this.form.school_id = this.school_id;
        if (!this.form.school_id) {
          this.$message({
            type: "warning",
            message: "请先选择学校"
          });
          return;
        }

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/mallConfig/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getInfo();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        });
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
